export default {
  //Adjustment - ADJ
  adj: {
    Open: "00",
    Pending: "10",
    Posted: "70",
    Cancelled: "99"
  },

  //Approve - APV
  apv: {
    ApprovalRequired: "10",
    Approved: "20",
    ApprovalNotRequired: "30",
    Rejected: "97"
  },

  //Sales Return - CRN
  crn: {
    New: "00",
    Waiting: "01",
    Rejected: "05",
    Approved: "06",
    Pending: "10",
    Printed: "60",
    Posted: "70",
    Cancelled: "99"
  },

  //Purchase Return - DRN
  drn: {
    Open: "00",
    Pending: "10",
    Posted: "70",
    Cancelled: "99"
  },

  // Goods Receive - GR
  gr: {
    Open: "00",
    Pending: "10",
    StockUpdated: "60",
    Posted: "70",
    PostedandAlloc: "75",
    Cancelled: "99"
  },

  //Invoice - INV
  inv: {
    Open: "00",
    Rejected: "04",
    ApprovalRequired: "05",
    ApprpvalRequiredManu: "06",
    Pending: "10",
    PartialPicked: "11",
    Picked: "12",
    Approved: "30",
    //PartialPicked : '31',
    //Picked : '32',
    Checked: "50",
    Printed: "60",
    Posted: "70",
    Hold: "80",
    Closed: "90",
    Cancelled: "99"
  },

  //Picking List - PL
  pl: {
    New: "00",
    Pending: "10",
    Picked: "20",
    Checking: "30",
    Checked: "40",
    Converted: "50"
  },

  //Purchase Order - PO
  po: {
    New: "00",
    Rejected: "05",
    Approved: "06",
    Pending: "10",
    Printed: "20",
    Temp: "27",
    Posted: "70",
    Hold: "80",
    Cancelled: "99"
  },

  //Sales Order - SO
  so: {
    Open: "00",
    Pending: "10",
    Returned: "15",
    Sent: "20",
    Invoiced: "30",
    Printed: "60",
    Posted: "70",
    Hold: "80",
    Closed: "90",
    Cancelled: "99"
  },

  // Stock Transfer - TXF
  txf: {
    New: "00",
    Pending: "10",
    Posted: "70",
    Cancelled: "99"
  },
  chartColor: {
Last2YearRIN: "#d4e6f7",
LastRIN: "#a6caec",
CurrentRIN: "#4e95d9",
Last2YearIN: "#d9d9d9",
LastIN: "#aeaeae",
CurrentIN: "#747474",
    LastOnline: "#84e291",
    CurrentOnline: "#00b050",
    YearsColor: [ "#f8d9b8",  "#f2b87a",  "#ea8f3c"] //"#f58220"
  }
};
